// src/components/Contact.jsx
import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CTAButton from './CTAButton';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

const Contact = () => {
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        const temp = {};
        if (!formValues.name.trim()) temp.name = "Name is required";
        if (!formValues.email.match(/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/))
            temp.email = "Valid email is required";
        if (!formValues.message.trim()) temp.message = "Message is required";
        return temp;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            try {
                const response = await fetch('https://wade-bros.com/sendmail.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formValues)
                });

                if (response.ok) {
                    toast.success("Message sent successfully!");
                    setFormValues({ name: '', email: '', phone: '', service: '', message: '' });
                } else {
                    throw new Error("Server error");
                }
            } catch (error) {
                toast.error("Failed to send message. Please try again.");
            }
        }
    };

    const openInstagram = () => {
        window.open('https://www.instagram.com/818wadebros/', '_blank', 'noopener,noreferrer');
    };

    const openFacebook = () => {
        window.open('https://www.facebook.com/profile.php?id=61573179695234', '_blank', 'noopener,noreferrer');
    };

    return (
        <section id="contact" className="contact section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Contact Us</h2>
                    <p className="section-subtitle">Get in touch for a quote or questions</p>
                </div>

                <div className="contact-grid">
                    <div className="contact-info">
                        <div className="info-item">
                            <h3 className="info-title">Business Name</h3>
                            <p className="info-text">Wade Bros Detailing</p>
                        </div>

                        <div className="info-item">
                            <h3 className="info-title">Contact</h3>
                            <p className="info-text">
                                Email: 818wadebros@gmail.com<br />
                                Phone: (818) 929-2241<br />
                                Alt Phone: (818) 207-5989
                            </p>
                        </div>

                        <div className="info-item">
                            <h3 className="info-title">Social Media</h3>
                            <div className="social-links">
                                <button onClick={openFacebook} className="social-link">
                                    <FaFacebookF className="social-icon" />
                                </button>
                                <button onClick={openInstagram} className="social-link">
                                    <FaInstagram className="social-icon" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name"
                                    value={formValues.name}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.name && <span className="error-text">{errors.name}</span>}
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email"
                                    value={formValues.email}
                                    onChange={handleChange}
                                    required
                                />
                                {errors.email && <span className="error-text">{errors.email}</span>}
                            </div>

                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number"
                                    value={formValues.phone}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <select
                                    name="service"
                                    value={formValues.service}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a Service</option>
                                    <option value="express">Express Wash</option>
                                    <option value="premium">Premium Detail</option>
                                    <option value="full">Full Detail</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <textarea
                                    name="message"
                                    placeholder="Your Message"
                                    rows="5"
                                    value={formValues.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                                {errors.message && <span className="error-text">{errors.message}</span>}
                            </div>

                            <CTAButton type="submit" text="Send Message" />
                        </form>
                        <ToastContainer position="bottom-right" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
